/**
 * Card for updating api token
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import LoadingPlaceHolder from 'components/LoadingPlaceholder/LoadingPlaceholder';
import ApiTokenFormContainer from './ApiTokenForm/ApiTokenFormContainer';
import ApiTokenItem from './ApiTokenItem/ApiTokenItemContainer';

const propTypes = {
  className: PropTypes.string,
  tokenState: PropTypes.shape({
    apitokens: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isLoading: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    apikey: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  className: null,
};

export function UnstyledApiTokenCard({ className, classes, tokenState }) {
  const { isLoading, apitokens } = tokenState;

  return (
    <Card className={className}>
      <CardHeader title="API Token" />
      <CardContent>
        {isLoading ? <LoadingPlaceHolder /> : null}
        {!isLoading && !apitokens.length ? (
          <ApiTokenFormContainer />
        ) : (
          apitokens.map((apitoken) => (
            <ApiTokenItem
              initialValues={{ id: apitoken.id }}
              className={classes.apikey}
              key={apitoken.id}
              id={apitoken.id}
              name={apitoken.name}
              token={apitoken.token}
            />
          ))
        )}
      </CardContent>
    </Card>
  );
}

UnstyledApiTokenCard.propTypes = propTypes;
UnstyledApiTokenCard.defaultProps = defaultProps;

const styles = (theme) => ({
  apikey: {
    color: theme.palette.text.primary,
  },
});

export default withStyles(styles)(UnstyledApiTokenCard);
